module.exports = __webpack_public_path__ + "img/vibration-mode.4e90f6e8.png";